<template>
  <div>
    <div class="body container" style="padding-bottom: 30px;">
      <!--导航-->
      <div class="nav clearfix">
        <a
          :class="{'active':column.id == columnid}"
          href="#"
          v-for="column in brotherColumnData"
          :key="column.id"
          @click="changeColumn(column.id, column.fix_column_name)"
        >{{column.title}}</a>
      </div>
      <div class="videoWrap" v-if="isLive && isShow">
        <div class="liveCover">
          <div class="toLiveInfo" @click="toInfo()">观看直播</div>
        </div>
      </div>
      <div class="videoWrap" v-else>
        <div class="videoBox">
          <div class="video-box" id="videoBox" style="background: rgb(69,70,75)">
            <h1
              style="font-size: 40px;font-weight: bold;line-height: 640px;text-align: center;color: #666"
            >当前没有直播列表</h1>
            <p>
              <i></i>
              <span>直播结束，感谢大家的参与。</span>
            </p>
          </div>
        </div>
      </div>
      <div class="video-list">
        <div class="title-l clearfix">
          <a class="active" href="javascript:">节目列表</a>
        </div>
        <div class="conten">
          <table>
            <thead>
              <tr>
                <th class="date">时间</th>
                <th class="tit">标题</th>
                <th class="name">主讲人</th>
                <th class="adm">权限</th>
                <th class="editBox">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data" :key="item.id" >
                <td class="date">{{item.start_end_time}}</td>
                <td class="tit">{{item.title}}</td>
                <td class="name">{{item.speakername}}</td>
                <td class="adm">{{item.cn_permission_scope}}</td>
                <td class="editBox">
                  <span v-if="item.status == 1" class="nothing">即将开始</span>
                  <a v-else-if="item.status == 2" class="watch active">直播中</a>
                  <a
                    v-else-if="item.status == 3 && item.video_resid"
                    @click="goBack(item)"
                    class="watch active"
                    style="cursor:pointer"
                  >回放</a>
                  <span v-else class="nothing">未上传视频</span>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr>
                <td colspan="5">
                  <div class="btnList clearfix">
                    <div class="btnGroup">
                      <el-pagination
                        background
                        hide-on-single-page
                        @current-change="PageChange"
                        layout="prev, pager, next"
                        :total="count"
                        :current-page="page"
                        :page-size="pageSize"
                      ></el-pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
          <div class="default" v-if="this.data.length == 0">
            <p>当前没有直播节目</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
export default {
  name: "school_webcast_tv",
  data() {
    return {
      isShow: false,
      info: "",
      page: 1,
      pageSize: 10,
      count: 0,
      recordcount: 0,
      columnid: this.$route.query.id, // 栏目id
      schoolid: this.$route.query.schoolid, // 学校id
      brotherColumnData: [], // 二级导航数据
      id: this.id,
      data: "", // 节目列表数据
      liveData: "", // 正在直播的数据
      isLive: true
    };
  },
  computed: {
     globalVaranthasInited(){
         return globalApi.gWebsiteSessionInfo.hasInited;
     }
  },
  watch: {
      globalVaranthasInited: function(){        
        
        this.init();
      },
  },
  created() {
    
  },

  methods: {
    init(){
         this.getOneData();
        this.getBrotherColumn();
        this.getData();
      },
    // 获取二级导航
    async getBrotherColumn() {
      let data = {
        s: "WebSchoolSpace.Column.GetBrotherColumn",
        columnid: this.columnid,
        weblevel: 1,
        incdisabled: 1
      };

      let res = await globalApi.post( data);
      this.brotherColumnData = res.data.data.reverse();
    },

    // 分页导航
    PageChange(val) {
      this.page = val;
      this.getData();
    },

    // 获取数据接口(正在直播的一条数据)
    async getOneData() {
      const data = {
        s: "WebSchoolSpace.WebCast.getList",
        page: 1,
        page_size: 1,
        type: 4, // 校园电视台类型
        status: 2 // /排序方式 1-即将开始 2-正在播放 3-直播历史
      };
      const response = await globalApi.post( data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.liveData = res.list[0];
      if (res.recordcount == 0) {
        this.isShow = true;
        this.isLive = false;
      } else {
        this.isShow = true;
        this.isLive = true;
      }
    },

    // 获取数据接口(节目列表)
    async getData() {
      const data = {
        s: "WebSchoolSpace.WebCast.getList",
        page: this.page,
        page_size: this.pageSize,
        type: 4 // 校园电视台类型
      };
      const response = await globalApi.post( data);
      const res = response.data.data;

      if (res.result == -1) {
        this.$message.error("服务器忙~请稍后再试!");
      }
      this.count = res.recordcount;
      this.data = res.list;
    },

    // 二级导航跳转
    changeColumn(id, address) {
      this.$router.push(
        String(address + "?id=" + id + "&schoolid=" + this.schoolid)
      );
    },

    // 跳转到直播页面
    // id       -课堂直播id
    // powerId  -课堂直播权限
    // schoolid -课堂直播学校id
    // status   -课堂直播状态
    toInfo() {
      var id = this.liveData.id;
      var powerId = this.liveData.permission_scope;
      var schoolid = this.liveData.schoolid;
      var status = this.liveData.status;
      var userid = this.liveData.userid;
      var isView = globalApi.checkViewPower(powerId, schoolid, userid); // 判断是否有权限
      if (isView == 1) {
        if (status == 2) {
          globalApi.jumpPath(2, "school_webcast_live_tv", "id=" + id); // 跳转直播页面
        } else {
          globalApi.jumpPath(2, "school_webcast_tv", "id=" + id); // 跳转视频播放页面
        }
      }
      if (isView == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
      }
      if (isView == 3) {
        this.$message.error("无访问权限!");
      }
    },

    // 回放(跳转到视频播放页面)
    // id       -课堂直播id
    // powerId  -课堂直播权限
    // schoolid -课堂直播学校id
    goBack(val) {
      var isView = globalApi.checkViewPower(val.permission_scope,val.schoolid);
      // 判断是否有权限
      if (isView == 1) {
        globalApi.jumpPath(2, "school_webcast_tv", "id=" + val.id); // 跳转视频播放页面
      }
      if (isView == 2) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
      }
      if (isView == 3) {
        this.$message.error("无访问权限!");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
.video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.videoWrap {
  margin: 30px 0;
  .liveCover {
    background: url("../../assets/img/Sinatv_default_status.png") no-repeat;
    width: 100%;
    height: 640px;
    position: relative;
    .toLiveInfo:hover {
      background: #0077ff;
      color: #fff;
    }
    .toLiveInfo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 200px;
      height: 70px;
      cursor: pointer;
      border: 1px solid #0077ff;
      border-radius: 10px;
      font-size: 24px;
      color: rgba(0, 119, 255, 1);
      line-height: 70px;
      text-align: center;
    }
  }
}
.video-list {
  position: relative;
  min-height: 553px;
  .conten {
    td {
      font-size: 14px;
    }
    tfoot {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 0);
    }
  }
}
</style>
<style lang="scss" scoped>
.default {
  font-size: 24px;
  line-height: 100px;
  text-align: center;
  font-weight: bold;
  background: #ccc;
  color: #fff;
}
</style>